export const partner = {
  bannerTextBig: 'MEHR KUNDENANFRAGEN FÜR IHREN BETRIEB!',
  bannerTextBigMobile: 'MEHR KUNDEN-ANFRAGEN FÜR IHREN BETRIEB!',
  bannerTextSmall:
    'Als Partner von HausHeld.ch erhalten Sie telefonisch geprüfte Anfragen von Hauseigentümern aus der Schweiz.',
  bannerButtonText: 'Jetzt Partner werden',
  bannerButtonTextFree: 'Jetzt kostenlos testen',
  bannerTextBelowButton: 'völlig unverbindlich und ohne versteckte Kosten!',
  becomePartner: 'Werden Sie Partner von HausHeld.ch!',
  becomePartnerText:
    'Auf dem Renovationsportal HausHeld.ch können Haus- und Stockwerkeigentümer Renovationswünsche aller Art äussern. Als unser Partner erhalten Sie anschliessend hochwertige Kundenanfragen aus der Schweiz. Alle Anfragen sind speziell auf Ihr Profil abgestimmt, werden telefonisch geprüft und bieten sehr gute Auftragsquoten.',
  offers: 'Anfragen mit Qualität',
  offersText:
    'HausHeld vermittelt Ihnen nur hochwertige Anfragen von seriösen Kunden mit tatsächlichem Renovationsinteresse',
  saveTime: 'Zeit sparen',
  saveTimeText:
    'Sie erhalten komplette und individuell geprüfte Anfragen, die Sie sofort angehen können',
  noObligations: 'Keine Verpflichtungen',
  noObligationsText:
    'Bei voller Auslastung oder Abwesenheit pausieren Sie einfach Ihr Profil und zahlen in dieser Zeit auch keine Gebühren',
  transparentCosts: 'Transparente Kosten',
  transparentCostsText:
    'Sie bestimmen selbst Ihr monatliches Budget und entscheiden, wieviel Sie zahlen wollen',
  contacts: 'Kontakte knüpfen',
  contactsText:
    'HausHeld verbindet Sie mit dem Kunden. Sie haben direkten Kontakt und gewinnen neue Stammkunden',
  orders: 'Hochwertige Aufträge',
  ordersText: 'Sie gewinnen den Auftrag und erhalten wertvolle Weiterempfehlungen',
  customerInquiries: 'Kundenanfragen nach Mass!',
  createProfile: '1. Profil erstellen',
  createProfileText:
    'In wenigen Schritten erstellen Sie Ihr HausHeld-Profil und definieren Ihre Bedürfnisse',
  defineBudget: '2. Budget festlegen',
  defineBudgetText:
    'Die Höhe Ihres Budgets bestimmt die Anzahl der möglichen Anfragen, die Sie erhalten können',
  getInquiry: '3. Anfrage erhalten',
  getInquiryText: 'HausHeld schickt Ihnen passende Anfragen, die auf Ihr Gewerk zugeschnitten sind',
  winInquiry: '4. Aufträge gewinnen',
  winInquiryText: 'Anfrager kontaktieren, Beratungstermin vereinbaren und der Auftrag gehört Ihnen',
  becomePartnerButtonText: 'Partner werden',
  testPhase: 'Ihre kostenlose Testphase',
  startTestPhase: 'Testphase starten',
  startTestPhaseText: 'In wenigen Minuten erstellen Sie Ihr Profil und Ihre Testphase startet',
  getOffers: 'Anfragen erhalten',
  getOffersText:
    'Während Ihrer Testphase erhalten Sie völlig kostenlos zwei geprüfte Kundenanfragen',
  noInterest: 'Kein Interesse mehr?',
  noInterestText: 'Dann brauchen Sie nichts weiter tun - Ihre Testphase endet automatisch',
  convinced: 'Überzeugt?',
  convincedText:
    'Über Ihr Partnerprofil können Sie eine Partnerschaft mit HausHeld eingehen, um weiterhin geprüfte Qualitätsanfragen zu erhalten',
  personalAccess: 'Ihr persönlicher Handwerkerzugang',
  personalAccessText:
    'Als Partner von HausHeld.ch erhalten Sie exklusiven Zugang zu Ihrem persönlichen Login-Bereich. Hier können Sie kinderleicht alle Einstellungen verwalten und haben Einsicht in Ihre neu erhaltenen Kundenanfragen. Ihr Profil ist nur für Sie selbst und für HausHeld einsehbar und wird nirgends veröffentlicht! Unsere Software ist zu 100% swissmade und wurde in Zusammenarbeit mit dem Schweizer Handwerk entwickelt.',
  testButtonText: 'Unverbindlich testen',
  getPartnerNow: 'Jetzt Partner werden',
  freeTrial: 'Jetzt Partner werden und kostenlose Testphase sichern!',
  continue: 'Weiter',
  return: 'Zurück',
  chooseService: 'Bitte wählen Sie Ihr Leistungsangebot',
  chooseRadius: 'Bitte wählen Sie Ihren Aktionsradius',
  quickSelection: 'Schnellauswahl',
  wholeSwitzerland: 'Ganze CH',
  solar: 'Solaranlagen',
  floorLayers: 'Bodenleger',
  awnings: 'Markisen',
  airCondition: 'Klima',
  fence: 'Zaun & Sichtschutz',
  railings: 'Geländer',
  alarmSystem: 'Alarmanlage',
  insulation: 'Isolation & Fassade',
  stairs: 'Treppe',
  assembly: 'Montage',
  blinds: 'Storen',
  realEstateAgent: 'Makler',
  painter: 'Maler & Gipser',
  winterGarden: 'Wintergarten',
  electrician: 'Elektriker',
  roofer: 'Dachdecker',
  gardener: 'Gärtner',
  plater: 'Plattenleger',
  joiner: 'Schreiner',
  architect: 'Architekt & Bauleiter',
  garages: 'Garagen & Tore',
  balcony: 'Balkon',
  metalConstruction: 'Metallbau',
  roofing: 'Überdachung & pergola',
  carpenter: 'Zimmermann',
  customerReview1Title: 'Wir konnten unseren Kundenstamm erweitern',
  customerReview1Text:
    'Wir sind ein junges Unternehmen im Bereich Haustechnik + Umbau mit Fokus auf höchste Kundenzufriedenheit und Qualität. HausHeld.ch half uns, unseren Kundenstamm mit spannenden Projekten zu erweitern und ebnete uns so den Weg für weiteres Wachstum. Freundliche Grüsse',
  customerReview1CompanyName: 'Stiel GmbH',
  customerReview1Name: 'Nis Stiel',
  customerReview1Address: 'Holzwiesstrasse 11',
  customerReview1City: '8704 Herrliberg',
  customerReview2Title: 'Passgenaue Kundenanfrage für mein Unternehmen',
  customerReview2Text:
    'Als kompletter Partner von der ersten Idee bis zum fertigen Umbau begleiten wir den Kunden innovativ und digital. HausHeld.ch ist dabei unser langjähriger Partner, damit wir genau zur richtigen Zeit die richtigen Kundenanfragen erhalten und so unsere Auslastung optimal steuern können.',
  customerReview2CompanyName: 'Reno Group GmbH',
  customerReview2Name: 'Florent Murati + Sascha Weber',
  customerReview2Address: 'Bahnhofstrasse 12',
  customerReview2City: '5605 Dottikon',
  faq: 'FAQs',
  partnerCosts: 'Welche Kosten kommen als Partner auf mich zu?',
  partnerCostsText:
    'Sie wählen ein monatliches Marketingbudget aus und erhalten bis zum Erreichen dieser Budgetgrenze hochwertige und passende Kundenanfragen. Ein geprüftes Kundenprofil erhalten Sie ab 9 CHF, die Preise variieren je nach Gewerk und geschätzten Auftragsvolumen.',
  partnerNotice: 'Gibt es in der aktiven Partnerschaft Kündigungsfristen?',
  partnerNoticeText: 'Nein, Sie können jederzeit kündigen. Eine einfache Mail genügt.',
  offerPayment: 'Welche Anfragen muss ich bezahlen?',
  offerPaymentText:
    'Wir stellen sicher, dass es sich um echte Anfragen handelt und die Anfrager auch erreichbar sind. Sie bezahlen nur die ausgewiesenen Leadpreise für die Leads, die Sie auch tatsächlich erhalten haben. Die Gebühr ist unabhängig vom Erfolgsfall fällig.',
  offerCosts: 'Gibt es weitere Kosten neben den Anfragegebühren?',
  offerCostsText: 'Nein, es fallen keinerlei Grund- oder Aufschaltungsgebühren an.',
  participation: 'Welche Anbieter dürfen mitmachen?',
  participationText:
    'Nur seriöse Qualitätsbetriebe dürfen mitmachen. Alle Betriebe müssen in der Schweiz ansässig sein. In Falle von Wiederkehrenden Kundenreklamation werden Betriebe von der Plattform ausgeschlossen.',
  tryIt: 'Einfach ausprobieren',
  comments: 'Haben Sie noch Bemerkungen?',
  comment: 'Bemerkung',
  send: 'Absenden',
  create: 'Partnerprofil erstellen',
  yourPartnership: 'Ihre Partnerschaft ohne Risiko',
  noMinimumContractDuration: 'Keine Mindestvertragslaufzeit',
  noMinimumContractDurationText: 'Ihre Partnerschaft mit HausHeld.ch können Sie jederzeit beenden',
  noBasicFees: 'Keine Grundgebühren',
  noBasicFeesText: 'Bei uns werden Sie von keinen versteckten Kosten überrascht',
  payWhatYouGet: 'Pay what you get',
  payWhatYouGetText: 'Sie bezahlen nur für Anfragen, welche Sie von uns vermittelt bekommen',
  questions: 'Haben Sie noch Fragen?',
  meeting: 'Vereinbaren Sie Ihr kostenloses Beratungsgespräch.',
  clickHere: 'Jetzt unverbindlich buchen',
}
